<div class="card mb-4 mx-0 mx-sm-4">
  <div class="card-body pb-0" [class.placeholder-glow]="isLoading()">
    <div class="d-flex flex-column flex-lg-row align-items-center">
      <!-- Avatar Section -->
      <div class="text-center text-lg-start mb-4 mb-lg-0">
        <ms-avatar [identity]="user()" [avatarSize]="avatarSize" [avatarShape]="avatarShape" [showUploadControls]="true"
          [isLoading]="isLoading()" (avatarChanged)="onAvatarChanged($event)" (avatarRemoved)="onAvatarRemoved()">
        </ms-avatar>
      </div>

      <!-- Profile Info Section -->
      <div class="flex-grow-1 ms-lg-4 text-center text-lg-start w-100 w-lg-auto min-w-0">
        <div class="d-flex flex-column flex-lg-row align-items-center align-items-lg-start justify-content-between">
          <div class="mb-3 mb-lg-0 me-lg-3 min-w-0 w-100">
            @if (isLoading()) {
            <div class="placeholder col-8 mb-2"></div>
            <div class="placeholder col-6"></div>
            } @else {
            <div class="d-flex align-items-center min-w-0 mb-1 justify-content-center justify-content-lg-start">
              <h2 class="fw-bold mb-0 text-truncate min-w-0" [msTooltip]="fullName()" msTooltipOnlyIfTruncated>
                {{user()?.firstName}} {{user()?.lastName}}
              </h2>
              @if (user()?.status) {
              <div class="ms-2 flex-shrink-0">
                <ms-status-badge [status]="user()?.status" [isLoading]="isLoading()"></ms-status-badge>
              </div>
              }
            </div>

            <div class="w-fit profile-info-mw text-start mx-auto mx-lg-0">
              @if (platformRole()) {
              <div class="d-flex align-items-center min-w-0">
                <fa-duotone-icon icon="briefcase" class="me-2 flex-shrink-0" secondaryOpacity="0.5"></fa-duotone-icon>
                <span class="text-truncate min-w-0" [msTooltip]="platformRole() ?? ''" msTooltipOnlyIfTruncated>
                  {{platformRole()}}
                </span>
              </div>
              }

              @if (user()?.emailAddress) {
              <div class="d-flex align-items-center min-w-0">
                <fa-duotone-icon icon="envelope" class="me-2 flex-shrink-0" secondaryOpacity="0.5"></fa-duotone-icon>
                <span class="text-truncate min-w-0"
                   [msTooltip]="user()?.emailAddress ?? ''" msTooltipOnlyIfTruncated>{{user()?.emailAddress}}</span>
              </div>
              }

              @if (user()?.phoneNumber) {
              <div class="d-flex align-items-center min-w-0">
                <fa-duotone-icon icon="phone" class="me-2 flex-shrink-0" secondaryOpacity="0.5"></fa-duotone-icon>
                <span class="text-truncate min-w-0" [msTooltip]="formattedPhone()" msTooltipOnlyIfTruncated>
                  {{user()?.phoneCountryCode | CountryCode}} {{user()?.phoneNumber | NANPFormattedPhone}} {{user()?.phoneExtension | PhoneExtension}}
                </span>
              </div>
              }
            </div>
            }
          </div>

          <div class="dropdown flex-shrink-0" ifHasChildPermission>
            <button class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" [class.placeholder]="isLoading()">
              <span>Actions</span>
            </button>
            <ul class="dropdown-menu dropdown-menu-end">
              @if (canShowEditProfile()) {
              <li>
                <a class="dropdown-item"
                  [class.disabled]="user()?.status === 'Deleted' || isCheckingProtection() || isProtectedFromModification()"
                  [attr.aria-disabled]="(user()?.status === 'Deleted' || isCheckingProtection() || isProtectedFromModification()) ? 'true' : null"
                  [attr.tabindex]="(user()?.status === 'Deleted' || isCheckingProtection() || isProtectedFromModification()) ? -1 : null"
                  (click)="user()?.status !== 'Deleted' && !isCheckingProtection() && !isProtectedFromModification() ? editProfileRequested.emit() : $event.stopPropagation()">
                  @if (isCheckingProtection()) {
                  <div class="spinner-border spinner-border-sm me-2" role="status"><span class="visually-hidden">Loading...</span></div>
                  } @else {
                  <fa-duotone-icon icon="edit" secondaryOpacity="0.9" class="me-2" />
                  }Edit Profile
                </a>
              </li>
              }
              @if (canShowReactivate() || canShowDeactivate() || canShowDelete()) {
              <li><hr class="dropdown-divider"></li>
              }
              @if (canShowReactivate()) {
              <li>
                <a class="dropdown-item" [class.disabled]="isCheckingProtection() || isProtectedFromModification()"
                  [attr.aria-disabled]="(isCheckingProtection() || isProtectedFromModification()) ? 'true' : null"
                  [attr.tabindex]="(isCheckingProtection() || isProtectedFromModification()) ? -1 : null"
                  (click)="(isCheckingProtection() || isProtectedFromModification()) ? $event.stopPropagation() : openReactivateModal(user()!)">
                  @if (isCheckingProtection()) {
                  <div class="spinner-border spinner-border-sm me-2" role="status"><span class="visually-hidden">Loading...</span></div>
                  } @else {
                  <fa-duotone-icon icon="power-off" secondaryOpacity="0.9" class="me-2" />
                  }Reactivate
                </a>
              </li>
              }
              @else if (canShowDeactivate()) {
              <li>
                <a class="dropdown-item" [class.disabled]="isCheckingProtection() || isProtectedFromModification()"
                  [attr.aria-disabled]="(isCheckingProtection() || isProtectedFromModification()) ? 'true' : null"
                  [attr.tabindex]="(isCheckingProtection() || isProtectedFromModification()) ? -1 : null"
                  (click)="(isCheckingProtection() || isProtectedFromModification()) ? $event.stopPropagation() : openDeactivateModal(user()!)">
                  @if (isCheckingProtection()) {
                  <div class="spinner-border spinner-border-sm me-2" role="status"><span class="visually-hidden">Loading...</span></div>
                  } @else {
                  <fa-duotone-icon icon="ban" secondaryOpacity="0.9" class="me-2" />
                  }Deactivate
                </a>
              </li>
              }
              @if (canShowDelete()) {
              <li>
                <a class="dropdown-item"
                  [class.disabled]="user()?.status === 'Deleted' || isCheckingProtection() || isProtectedFromModification()"
                  [attr.aria-disabled]="(user()?.status === 'Deleted' || isCheckingProtection() || isProtectedFromModification()) ? 'true' : null"
                  [attr.tabindex]="(user()?.status === 'Deleted' || isCheckingProtection() || isProtectedFromModification()) ? -1 : null"
                  (click)="user()?.status !== 'Deleted' && !isCheckingProtection() && !isProtectedFromModification() ? confirmUserDeletion() : $event.stopPropagation()">
                  @if (isCheckingProtection()) {
                  <div class="spinner-border spinner-border-sm me-2" role="status"><span class="visually-hidden">Loading...</span></div>
                  } @else {
                  <fa-duotone-icon icon="trash" secondaryOpacity="0.9" class="me-2" />
                  }Delete
                </a>
              </li>
              }
            </ul>
          </div>
          
        </div>
      </div>
    </div>
  </div>


  <!-- Navigation Tabs -->
  <div class="profile-nav-container mt-4">
    <ms-responsive-tabs [navItems]="navItems() ?? []" (tabChanged)="onTabClick($event)" />
  </div>
</div>

<ms-confirmation-modal #userProfileHeaderConfirmationModalRef 
    modalId="userProfileHeaderConfirmationModal" 
    confirmButtonText="Deactivate" 
    cancelButtonText="Cancel"
    [(isSubmitting)]="isSubmitting"
    (confirmed)="confirmationConfirmFunction($event)"
    (cancelled)="confirmationCancelFunction()"
/>

<ms-info-modal #userProfileHeaderInfoModalRef 
    modalId="userProfileHeaderInfoModal" 
/>
